import { IValidationRule } from "@/types"

const invoicePositionValidationRules: { [s: string]: IValidationRule } = {
    number: {
        type: "alphanumeric",
        required: true,
    },
    distributionRule:{
        required:true
    },
    description: {
        required: true,
    },
}

export default invoicePositionValidationRules
